export default __webpack_public_path__ + "static/media/us_5.6d564e26.mp3";